import { api } from "../../services/NetworkBase";

export async function GetAllCoolers() {
  try {
    let response = await api
      .get(`vlp/coolers`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetCoolerById(coolerId) {
  try {
    let response = await api.get(`vlp/coolers/${coolerId}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetCoolerByBarcode(coolerId) {
  try {
    let response = await api
      .get(`vlp/coolers/barcode/${encodeURIComponent(coolerId)}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetCoolersByClient(clientAccountNumber) {
  try {
    let response = await api
      .get(`vlp/coolers/client/${encodeURIComponent(clientAccountNumber)}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveCooler(cooler) {
  try {
    let response = await api.post("vlp/coolers", { json: cooler });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateCooler(cooler) {
  try {
    let response = await api.put("vlp/coolers", { json: cooler });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteCooler(id) {
  try {
    let response = await api
      .delete(`vlp/coolers/${encodeURIComponent(id)}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function CheckInCooler(coolerId, coolerProfileId) {
  try {
    let response = await api
      .put(
        `vlp/coolers/${encodeURIComponent(coolerId)}/check-in?coolerProfileId=${coolerProfileId}`
      )
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function CheckOutCooler(coolerId, clientAccountNumber, bottleOrderNumber = null) {
  try {
    let url = `vlp/coolers/${encodeURIComponent(coolerId)}/check-out?clientAccountNumber=${clientAccountNumber}`;
    if (bottleOrderNumber != null) url += `&bottleOrderNumber=${bottleOrderNumber}`;
    let response = await api.put(url).json();
    return response;
  } catch (error) {
    throw error;
  }
}